 <!-- PDF -->
    <h5>PRONUNCIAMIENTO CERO TOLERANCIA TECNM </h5>
 <p>    ITESCARCEGA QUEJAS Y SUGERENCIAS  Última actualización: 12 Octubre 2021   </p>
    <div class="pdf-container">
      <iframe 
        src="assets/carrusel_proteccion_civil/Pronunciamiento_Cero_Tolerancia_TecNM.pdf" 
        frameborder="0">
      </iframe>
    </div>

     <!-- PDF -->
    <h5>PROCEDIMIENTO PARA LA PREVENCIÓN, ATENCIÓN Y SANCIÓN DE QUEJAS  </h5>
 <p>       ITESCARCEGA QUEJAS Y SUGERENCIAS  Última actualización: 10 Septiembre 2021    </p>
    <div class="pdf-container">
      <iframe 
        src="assets/carrusel_proteccion_civil/prevencion.pdf" 
        frameborder="0">
      </iframe>
    </div>